import { FC as ReactFC } from 'react';

import * as intl from 'react-intl-universal';
import { Button } from 'reactstrap';

import { formatDate, getDaysRemaining } from 'helpers/DateFormat';
import EllipsisTooltip from 'shared/components/ellipsis-tooltip/EllipsisTooltip';
import DateFormatType from 'shared/enums/DateFormatType';

import MfaTrustedDevicesListItemProps from './MfaTrustedDevicesListItemProps';

const MfaTrustedDevicesListItem: ReactFC<MfaTrustedDevicesListItemProps> = (
  props: MfaTrustedDevicesListItemProps
) => {
  const {
    device: { id, os, browser, expiresAt, createdAt },
    onRevokeTrustedDevice,
  } = props;

  const formattedCreationDate = formatDate(createdAt, DateFormatType.Default);
  const formattedExpiresAt = getDaysRemaining(expiresAt);
  const daysToExpire = intl.get('LBL_MFA_TRUSTED_DEVICES_EXPIRING_IN', {
    days: formattedExpiresAt,
  });

  return (
    <tr>
      <td className="truncate-long-words">
        <EllipsisTooltip
          tag="span"
          data-place="bottom"
          data-for="insTooltip"
          data-tip={os}
          data-class="overflow-wrap bring-it-up"
          className="table-content text-12-bold"
        >
          {os}
        </EllipsisTooltip>
      </td>
      <td className="truncate-long-words">
        <EllipsisTooltip
          tag="span"
          data-place="bottom"
          data-for="insTooltip"
          data-tip={browser}
          data-class="overflow-wrap bring-it-up"
          className="table-content text-12-bold"
        >
          {browser}
        </EllipsisTooltip>
      </td>
      <td>
        <EllipsisTooltip
          tag="span"
          data-place="bottom"
          data-for="insTooltip"
          data-tip={formattedCreationDate}
          data-class="overflow-wrap bring-it-up"
          className="table-content text-12-bold"
        >
          {formattedCreationDate}
        </EllipsisTooltip>
      </td>
      <td className="truncate-long-words">
        <EllipsisTooltip
          tag="span"
          data-place="bottom"
          data-for="insTooltip"
          data-tip={daysToExpire}
          data-class="overflow-wrap bring-it-up"
          className="table-content text-12-bold"
        >
          {daysToExpire}
        </EllipsisTooltip>
      </td>
      <td>
        <Button
          className="btn btn-primary btn-sm"
          onClick={() => onRevokeTrustedDevice(id)}
        >
          {intl.get('BTN_MFA_REVOKE')}
        </Button>
      </td>
    </tr>
  );
};

export default MfaTrustedDevicesListItem;
